import { render, staticRenderFns } from "./CnPrivacyPolicy.vue?vue&type=template&id=392a599e&scoped=true"
import script from "./CnPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./CnPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "392a599e",
  null
  ,true
)

export default component.exports